import config from '../constants';

declare global {
  interface Window {
    grecaptcha: any;
  }
}

let recaptchaLoaded = false;
let recaptchaLoading = false;

const loadRecaptchaScript = () => {
  if (recaptchaLoaded || recaptchaLoading || !config.recaptcha_site_key) {
    return;
  }

  recaptchaLoading = true;
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${config.recaptcha_site_key}`;
  script.async = true;
  script.onload = () => {
    recaptchaLoaded = true;
    recaptchaLoading = false;
  };
  script.onerror = () => {
    recaptchaLoading = false;
    console.error('Failed to load reCAPTCHA script');
  };
  document.head.appendChild(script);
};

// Load the script when the module is imported
loadRecaptchaScript();

export const grecaptcha = (callback: (token?: string) => void, action: string) => {
  if (!config.recaptcha_site_key) {
    console.warn('reCAPTCHA site key not configured');
    callback();
    return;
  }

  // If script is not loaded yet, try again in a bit
  if (!window.grecaptcha && !recaptchaLoaded) {
    setTimeout(() => grecaptcha(callback, action), 500);
    return;
  }

  if (window.grecaptcha) {
    try {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(config.recaptcha_site_key, { action })
          .then((token: string) => {
            callback(token);
          })
          .catch((error: any) => {
            console.error('reCAPTCHA execution failed:', error);
            callback();
          });
      });
    } catch (error) {
      console.error('reCAPTCHA error:', error);
      callback();
    }
  } else {
    console.warn('reCAPTCHA not available');
    callback();
  }
};
